import React from 'react'
import PrivacyEN from './PrivacyEN'
import PrivacyPT from './PrivacyPT'
import PrivacyRU from './PrivacyRU'
import PrivacyID from './PrivacyID'
import PrivacyZH from './PrivacyZH'
import PrivacyVN from './PrivacyVN'
import BackLink from '../ui/buttons/BackLink'
import { Helmet } from "react-helmet"

const content = () => {
  let html;

  switch(window.COUNTRY) {
    case 'RU':
      html = PrivacyRU;
      break;
    case 'CN':
      html = PrivacyZH;
      break;
    case 'ID':
      html = PrivacyID;
      break;
    case 'VN':
      html = PrivacyVN;
      break;
    case 'BR':
      html = PrivacyPT;
      break;
    default:
      html = PrivacyEN;
  }

  return { __html: html };
}

const title = () => {
  return {
    CN: '《保密策略》',
    BR: 'Política de privacidade',
    RU: 'Политика конфиденциальности - Олимпиада "BRICSMATH"'
  }[window.COUNTRY] || 'Privacy policy - Competition "BRICSMATH"'
}

const Privacy = (props) => {
  return (
    <div className="static">
      <Helmet>
        <title>{ title() }</title>
      </Helmet>
      <BackLink />
      <div dangerouslySetInnerHTML={ content() } />
    </div>
  )
}

export default Privacy
